import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import LastWeek from '../views/LastWeek.vue'
import All from '../views/All.vue'
import Login from '../views/Login.vue'
import UserInfo from '../views/UserInfo.vue'
import UserHistory from '../views/User_History.vue'
import UsedCode from '../views/UsedCode.vue'
import CheckCode from '../views/CheckCode.vue'
import CheckPhone from '../views/CheckPhone.vue'
import BlockList from '../views/BlockList.vue'
import NotFoundPage from '../views/NotFoundPage.vue'
import EntryIndex from '../views/Entry/EntryIndex.vue'
import Report from '../views/Report.vue'
import DashBoard from '../views/DashBoard.vue'
import VoucherImport from '../views/VoucherImport.vue'
Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/',
  //   name: 'Today',
  //   component: Today,
  //   meta: {
  //     isLogin: true,
  //   }
  // },
  {
    path: '/',
    name: 'Today',
    component: Home,
    meta: {
      isLogin: true,
      CRM: true,
      Roles: ['GUEST', 'MANAGER', 'USER']
    }
  },
  {
    path: '/crm/entries/:Request_ID?',
    name: 'CRM_Entry_Index',
    component: EntryIndex,
    meta: {
      isLogin: true,
      CRM: true,
      Roles: ['MANAGER', 'USER']
    }
  },
  {
    path: '/Report',
    name: 'Report',
    component: Report,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/EntryIndex',
    name: 'EntryIndex',
    component: EntryIndex,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/DashBoard',
    name: 'DashBoard',
    component: DashBoard,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/VoucherImport',
    name: 'VoucherImport',
    component: VoucherImport,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/UsedCode',
    name: 'UsedCode',
    component: UsedCode,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/CheckCode',
    name: 'CheckCode',
    component: CheckCode,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/CheckPhone',
    name: 'CheckPhone',
    component: CheckPhone,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/BlockList',
    name: 'BlockList',
    component: BlockList,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/LastWeek',
    name: 'LastWeek',
    component: LastWeek,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/All',
    name: 'All',
    component: All,
    meta: {
      isLogin: true,
    }
  },
  {
    path: '/About',
    name: 'About',
    meta: {
      isLogin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/Login',
    name: 'Login',
    component: Login
  },
  {
    path: '/UserInfo',
    name: "UserInfo",
    component: UserInfo,
    meta: {
      isLogin: true
    },
  },
  {
    path: '/UserHistory',
    name: "UserHistory",
    component: UserHistory,
    meta: {
      isLogin: true
    },
  },
  {
    path: '/*',
    name: "404 NOT FOUND",
    component: NotFoundPage,
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
export default router
